import {flattenRoutes, routesPosition, RoutesProps} from '../router.config';
import RootScreen from '../../screens/RootScreen';
import {dashboardRoutes} from './dashboard';
import {importRoutes} from './import';
import NotFound from '../../components/Error/NotFound';
import {Profiles} from "../../model/Group";
import {userProfileRoute} from "./profile";
import {exportRoutes} from "./export";
import LogoutScreen from "../../screens/logout-screen";

export const mainRoute: RoutesProps = {
    path: '/',
    position: routesPosition.leftSideBar,
    element: <RootScreen/>,
    children: [
        dashboardRoutes,
        importRoutes,
        exportRoutes,
        userProfileRoute,
    ],
    handle: {
        crumb: 'Dashboard',
    },
    errorElement: <NotFound/>,
    accessControl: [Profiles.ROLE_USER, Profiles.ROLE_ADMIN, Profiles.ROLE_SUPER_ADMIN],
};

export const logoutRoute: RoutesProps = {
    path: '/logout',
    position: routesPosition.leftSideBar,
    element: <LogoutScreen/>,
    errorElement: <NotFound/>,
    accessControl: [Profiles.ROLE_USER, Profiles.ROLE_ADMIN, Profiles.ROLE_SUPER_ADMIN],
};

const routes = [mainRoute, logoutRoute];
const flattenedRoutes = flattenRoutes(routes);

export {routes, flattenedRoutes};
